<template>
  <div>
    <table>
      <tr>
        <td>IBAN</td>
        <td>
          <SogDataLabel
            :value="_ibanSplit"
          />
        </td>
      </tr>
      <tr>
        <td>BIC</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.Bic)" />
        </td>
      </tr>
      <tr>
        <td>Bank</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.Bank)" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {computed} from "vue";

interface Props {
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    details: undefined
  }
)

const _ibanSplit = computed(() => {
  const iban = props.details?.getValue(PersonDetailsId.Iban)
  return iban?.match(/.{1,4}/g)?.join(' ');
})


</script>

<style scoped>
td {
  padding-right: 10px;
}

</style>
